class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = this.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams);
  }

  renderPage(searchParams) {
    const productGrid = document.querySelector('#main-collection-product-grid, #main-search-product-grid');
    if (!productGrid) return;
    
    const sectionId = productGrid.dataset.id;
    const url = `${window.location.pathname}?${searchParams}`;
    
    window.location.href = url;
  }
}

customElements.define('facet-filters-form', FacetFiltersForm);
